import { find } from 'lodash';
import { mapActions } from 'vuex';

const externalLinksMixin = {
  data() {
    return {
      links: null,
    };
  },
  methods: {
    ...mapActions('user', ['getExternalLogins']),
    registrationTrack(label) {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label,
      });
    },
    twitterLinkClick() {
      this.registrationTrack('Twitter');
      window.location = this.twitterLink;
    },
    facebookLinkClick() {
      this.registrationTrack('Facebook');
      window.location = this.facebookLink;
    },
  },
  computed: {
    twitterLink() {
      const data = find(this.links, l => l.name === 'Twitter');
      return data ? `${process.env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
    facebookLink() {
      const data = find(this.links, l => l.name === 'Facebook');
      return data ? `${process.env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
  },
};


export default externalLinksMixin;



// WEBPACK FOOTER //
// ./src/mixins/externalLinks.js